import React, { useEffect, useRef, useState } from 'react'
import DOMPurify from 'dompurify';
import { CTA } from 'types/campaign/collaborations';
import { sanitizeURLs } from 'utils/helpers';

interface ChoiceProps {
    options: string[] | CTA[],
    selected: string | CTA | boolean | undefined | File,
    onChange: (choice: string | CTA) => void
}

interface ChoiceBoxProps {
    content: string | CTA,
    onCheck: () => void,
    checked: boolean
}

const ChoiceBox: React.FC<ChoiceBoxProps> = ({ content, onCheck, checked }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const contentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (contentRef.current) {
            setIsOverflowing(contentRef.current.scrollHeight > 220); // same as max-height
        }
    }, []);

    const handleCheckboxToggle = (e: any) => {
        if (e.target.checked) {
            onCheck();
        }
    }

    return (
        <div className={`choice-box ${checked ? 'selected' : ''}`}>
            <div className="gig-selection-checkbox-wrapper">
                <input
                    type="checkbox"
                    className="form-check-input gig-selection-check-input"
                    checked={checked}
                    onChange={handleCheckboxToggle}
                />
            </div>
            <div style={{ flex: 1 }}>
                <div
                    className={`content-wrapper ${isExpanded ? 'expanded' : ''}`}
                    ref={contentRef}
                >
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(sanitizeURLs(typeof content === 'string' ? content : (content.text ?? ''))),
                        }}
                    />
                    {!isExpanded && isOverflowing && <div className="fade-overlay" />}
                </div>
                {isOverflowing && (
                    <div
                        className="read-more-button"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? 'Show less' : 'Read more'}
                    </div>
                )}
            </div>
        </div>
    )
}

const Choice: React.FC<ChoiceProps> = ({ options, selected, onChange }) => {
    return (
        <React.Fragment>
            {/* <span className="choices-label">Choose any 1 out of {options.length}</span> */}
            <div className='d-flex flex-column gap-3 mt-3'>
                {
                    options.map((option, i) => {
                        return (
                            <ChoiceBox
                                key={i}
                                content={option}
                                onCheck={() => onChange(option)}
                                checked={option === selected}
                            />
                        )
                    })
                }
                {
                    options.length === 0 &&
                    <span>The brand has not provided any options to choose from yet.</span>
                }
            </div>
        </React.Fragment>
    )
}

export default Choice